import filesUploadStoreFactory from 'hooks/filesUploadStoreFactory';

const useExpensesFilesUploadStore = filesUploadStoreFactory();

export default useExpensesFilesUploadStore;
